var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"FansRecommendedMaterial"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('PicList',_vm._g(_vm._b({staticClass:"PicList",attrs:{"params":"params"}},'PicList',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }